/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { TextField } from '@mui/material'
import { forwardRef } from 'react'



const TelephoneCustomComponentRef = (props:any, ref:any) => {
    var {placeholder, ...other} = props;

  return (
    <>
    <TextField
      {...other}
      inputRef={ref}
      fullWidth
      error={!!props.error}

      label={props.placeholder}
      
      
      
    />
    </>
  )
}
export default forwardRef(TelephoneCustomComponentRef)